import React from "react";

const CenterImage = ({ strokeColor, plateColor, bottomPlateColor }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 118 141"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.836 140.489C85.092 140.489 114.309 126.374 115.244 116.67L28.294 104.099C16.14 107.628 0.946999 115.479 0.946999 123.948C0.946999 134.535 20.581 140.489 52.836 140.489Z"
        fill={bottomPlateColor}
      />
      <path
        d="M116.597 116.363C116.597 119.007 115.257 121.65 112.66 124.037C110.062 126.425 106.292 128.642 101.684 130.433C92.384 134.099 79.397 136.402 65.07 136.402C50.743 136.402 37.84 134.099 28.456 130.433C23.848 128.557 20.078 126.425 17.48 124.037C14.883 121.65 13.542 119.092 13.542 116.363C13.542 113.72 14.883 111.076 17.48 108.689C20.078 106.301 23.848 104.084 28.456 102.294C37.756 98.627 50.743 96.325 65.07 96.325C79.397 96.325 92.3 98.627 101.684 102.294C106.376 104.17 110.146 106.301 112.66 108.689C115.257 111.076 116.597 113.72 116.597 116.363Z"
        fill={plateColor}
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path
        d="M116.597 84.874C116.597 87.518 115.257 90.161 112.66 92.548C110.062 94.936 106.292 97.153 101.684 98.944C92.384 102.61 79.397 104.913 65.07 104.913C50.743 104.913 37.84 102.61 28.456 98.944C23.848 97.068 20.078 94.936 17.48 92.548C14.883 90.161 13.542 87.603 13.542 84.874C13.542 82.146 14.883 79.587 17.48 77.2C20.078 74.812 23.848 72.595 28.456 70.805C37.756 67.138 50.743 64.836 65.07 64.836C79.397 64.836 92.3 67.138 101.684 70.805C106.376 72.681 110.146 74.812 112.66 77.2C115.257 79.587 116.597 82.231 116.597 84.874Z"
        fill={plateColor}
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path d="M116.598 84.308V115.796" stroke={strokeColor} strokeWidth="2" />
      <path d="M13.542 84.308V115.796" stroke={strokeColor} strokeWidth="2" />
      <path
        d="M116.597 84.816C116.597 87.459 115.257 90.102 112.66 92.49C110.062 94.877 106.292 97.094 101.684 98.885C92.384 102.552 79.397 104.854 65.07 104.854C50.743 104.854 37.84 102.552 28.456 98.885C23.848 97.009 20.078 94.877 17.48 92.49C14.883 90.102 13.542 87.544 13.542 84.816C13.542 82.172 14.883 79.529 17.48 77.141C20.078 74.754 23.848 72.537 28.456 70.746C37.756 67.079 50.743 64.777 65.07 64.777C79.397 64.777 92.3 67.079 101.684 70.746C106.376 72.622 110.146 74.754 112.66 77.141C115.257 79.529 116.597 82.172 116.597 84.816Z"
        fill={plateColor}
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path
        d="M116.597 53.327C116.597 55.97 115.257 58.613 112.66 61.001C110.062 63.388 106.292 65.605 101.684 67.396C92.384 71.063 79.397 73.365 65.07 73.365C50.743 73.365 37.84 71.063 28.456 67.396C23.848 65.52 20.078 63.388 17.48 61.001C14.883 58.613 13.542 56.055 13.542 53.327C13.542 50.598 14.883 48.04 17.48 45.652C20.078 43.265 23.848 41.048 28.456 39.257C37.756 35.59 50.743 33.288 65.07 33.288C79.397 33.288 92.3 35.59 101.684 39.257C106.376 41.133 110.146 43.265 112.66 45.652C115.257 48.04 116.597 50.683 116.597 53.327Z"
        fill={plateColor}
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path d="M116.598 52.76V84.248" stroke={strokeColor} strokeWidth="2" />
      <path d="M13.542 52.76V84.248" stroke={strokeColor} strokeWidth="2" />
      <path
        d="M116.597 53.269C116.597 55.913 115.257 58.556 112.66 60.943C110.062 63.331 106.292 65.548 101.684 67.339C92.384 71.005 79.397 73.308 65.07 73.308C50.743 73.308 37.84 71.005 28.456 67.339C23.848 65.463 20.078 63.331 17.48 60.943C14.883 58.556 13.542 55.998 13.542 53.269C13.542 50.626 14.883 47.982 17.48 45.595C20.078 43.207 23.848 40.99 28.456 39.2C37.756 35.533 50.743 33.231 65.07 33.231C79.397 33.231 92.3 35.533 101.684 39.2C106.376 41.076 110.146 43.207 112.66 45.595C115.257 47.982 116.597 50.626 116.597 53.269Z"
        fill={plateColor}
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path
        d="M116.597 21.78C116.597 24.424 115.257 27.067 112.66 29.454C110.062 31.842 106.292 34.059 101.684 35.85C92.384 39.516 79.397 41.819 65.07 41.819C50.743 41.819 37.84 39.516 28.456 35.85C23.848 33.974 20.078 31.842 17.48 29.454C14.883 27.067 13.542 24.509 13.542 21.78C13.542 19.052 14.883 16.493 17.48 14.106C20.078 11.718 23.848 9.501 28.456 7.711C37.756 4.044 50.743 1.742 65.07 1.742C79.397 1.742 92.3 4.044 101.684 7.711C106.376 9.587 110.146 11.718 112.66 14.106C115.257 16.493 116.597 19.137 116.597 21.78Z"
        fill={plateColor}
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path d="M116.598 21.214V52.702" stroke={strokeColor} strokeWidth="2" />
      <path d="M13.542 21.214V52.702" stroke={strokeColor} strokeWidth="2" />
    </svg>
  );
};

export default CenterImage;
